import Vue from "vue";
import Router from "vue-router";
import Signup from "@/pages/Signup.vue";
import Signin from "@/pages/Signin.vue";
import UserTop from "@/pages/UserTop.vue";
import LandingPage from "@/pages/LandingPage.vue";
import UserWordNote from "@/pages/UserWordNote.vue";
import WordNoteTest from "@/pages/WordNoteTest.vue";
import WordNoteTestMode from "@/pages/WordNoteTestMode.vue";
import WordNoteTestDone from "@/pages/WordNoteTestDone.vue";
import store from "../plugins/store";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      component: LandingPage,
    },
    {
      path: "/signup",
      component: Signup,
    },
    {
      path: "/signin",
      component: Signin,
    },
    {
      path: "/user",
      component: UserTop,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/word-note",
      component: UserWordNote,
      name: "word-note",
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/word-note/test",
      component: WordNoteTest,
      name: "word-note-test",
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/word-note/test-mode",
      component: WordNoteTestMode,
      name: "word-note-test-mode",
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/word-note/test-done",
      component: WordNoteTestDone,
      name: "word-note-test-done",
      meta: {
        authRequired: true,
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((page) => page.meta.authRequired) && !store.getters.uid) {
    next("/");
  } else if (to.path == "/" && store.getters.uid) {
    next("/user");
  } else {
    next();
  }
});

export default router;
